import { classNames } from "primereact/utils";
import styles from "./ServiceTypeListItem.module.scss";
import { IServiceTypeInputModel } from "../models/serviceTypeInputModel";
import { SkeletonItem } from "../../../../common/components/skeletons/SkeletonItem";
import { PriceDisplay } from "../../../../common/components/PriceDisplay";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";

interface IServiceTypeListItemProps {
  className?: string;
  item?: IServiceTypeInputModel;
  isLoading: boolean;
  actionButtons?: React.ReactNode;
}

export const ServiceTypeListItem = ({
  className,
  item,
  isLoading,
  actionButtons,
}: IServiceTypeListItemProps) => {
  const formatDuration = (minutes?: number) => {
    if (!minutes) return "";
    if (minutes < 60) return `${minutes} мин`;
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;
    return remainingMinutes > 0
      ? `${hours}ч ${remainingMinutes}м`
      : `${hours}ч`;
  };

  return (
    <div
      className={classNames(className, styles.item, {
        [styles.item_deleted]: item?.isDeleted,
      })}
    >
      <div className={styles.item_skeleton_wrapper}>
        <SkeletonItem
          isLoading={isLoading}
          value={
            <div className={styles.item_wrapper}>
              <div
                className={styles.item_main_colorIndicator}
                style={{ backgroundColor: `#${item?.color}` }}
              />
              <div className={styles.item_main}>
                <div className={styles.item_main_name}>
                  {item?.name}
                  <span className={styles.item_main_name_id}>
                    (ID: {item?.id})
                  </span>
                </div>
                <div className={styles.item_main_details}>
                  {item?.durationInMinutes && (
                    <span className={styles.item_main_details_duration}>
                      {formatDuration(item?.durationInMinutes)}
                    </span>
                  )}

                  {!!item?.bufferAfterMinutes && (
                    <span className={styles.item_main_details_buffer}>
                      +{formatDuration(item.bufferAfterMinutes)} буфер
                    </span>
                  )}

                  <span className={styles.item_main_details_separator}>•</span>

                  <span
                    className={classNames(styles.item_main_details_booking, {
                      [styles.item_main_details_booking_enabled]:
                        item?.allowOnlineBooking,
                      [styles.item_main_details_booking_disabled]:
                        !item?.allowOnlineBooking,
                    })}
                  >
                    {item?.allowOnlineBooking
                      ? "Онлайн записване"
                      : "Без онлайн записване"}
                  </span>

                  <RenderWhen condition={!!item?.isRemote}>
                    <span className={styles.item_main_details_separator}>•</span>

                    <span className={styles.item_main_details_remote}>
                      Дистанционна
                    </span>
                  </RenderWhen>

                  <span className={styles.item_main_details_separator}>•</span>

                  {item?.minPrice !== undefined && (
                    <span className={styles.item_main_details_duration}>
                      <PriceDisplay minPrice={item.minPrice} maxPrice={item.maxPrice} />
                    </span>
                  )}
                </div>
              </div>
            </div>
          }
        />
      </div>
      {actionButtons}
    </div>
  );
};
